"use client";

import { useEffect, useState } from "react";

export type Theme = "light" | "dark" | "system";

function getSystemTheme(): "light" | "dark" {
  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

function getCurrentTheme(): "light" | "dark" {
  return document.documentElement.classList.contains("dark") ? "dark" : "light";
}

export function useTheme() {
  const [theme, setThemeState] = useState<Theme>("system");
  const [resolved, setResolved] = useState<"light" | "dark">("light");

  useEffect(() => {
    const saved = (localStorage.getItem("theme") as Theme) || "system";
    setThemeState(saved);
    setResolved(getCurrentTheme());
  }, []);

  const setTheme = (next: Theme) => {
    localStorage.setItem("theme", next);
    setThemeState(next);

    const applied = next === "system" ? getSystemTheme() : next;

    document.documentElement.classList.remove("light", "dark");
    document.documentElement.classList.add(applied);
    setResolved(applied);
  };

  return { theme, resolvedTheme: resolved, setTheme };
}
